export type BantReportVariant = 'teacher' | 'psychologist' | 'parent';
